import * as React from "react";
import { useState, useEffect } from "react";
import QuestTabs from "@/components/molecules/quests/quest-tabs";
import QuestList from "@/components/molecules/quests/quest-list";
import { QuestType, Quest } from "@/types/quests";
import { questsBackend } from "@/services/questsBackend";
import { useTonConnect } from "@/hooks/useTonConnect";
import { Address } from "@ton/core";

interface QuestsProps {
  selectedTab: QuestType;
  onTabChange: (tab: QuestType) => void;
}

export default function Quests({ selectedTab, onTabChange }: QuestsProps) {
  const [quests, setQuests] = useState<Quest[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { wallet } = useTonConnect();
  console.log("Wallet to call quests:", wallet);
  useEffect(() => {
    fetchQuests();
  }, [selectedTab, wallet]);

  const fetchQuests = async () => {
    setIsLoading(true);
    setError(null);
    try {
      console.log("Wallet to call quests 2:", wallet);
      const response = await questsBackend.getQuestsList(wallet ? Address.parse(wallet).toString() : undefined);
      console.log("Quests list:", response);
      if (response.success) {
        setQuests(response.quests);
      } else {
        setError("Failed to fetch quests");
      }
    } catch (err) {
      setError("An error occurred while fetching quests");
      console.error("Error fetching quests:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div className="relative w-full aspect-[3/1]">
        <img src="/assets/quests/background.gif" alt="quests-bg" />
        <div className="absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center">
          <h1 className="text-[44px]">QUESTS</h1>
        </div>
      </div>

      <QuestTabs selectedTab={selectedTab} onTabChange={onTabChange} />

      {error ? (
        <div className="text-primary-red text-center mt-5">Error: {error}</div>
      ) : (
        <QuestList quests={quests} isLoading={isLoading} />
      )}
    </div>
  );
}
